import { defineMessages } from 'react-intl';

// Main route
const customerCareScope = 't.page.customerCare';
const transactionsScope = 't.page.transactions';

// Global scope
const globalScope = 't.global';

// Navigation
const navigationScope = 't.component.PortalAppNavigation';

// Global errors
const globalErrorsScope = 't.global.error';

export default defineMessages({
	// Customer Care Scoper
	successfullyDelete: {
		id: `${customerCareScope}.successfullyDelete`,
		defaultMessage: 'Utente eliminato con successo',
	},
	failureDelete: {
		id: `${customerCareScope}.failureDelete`,
		defaultMessage: 'Eliminazione utente fallita',
	},
	successfullyBlocked: {
		id: `${customerCareScope}.successfullyBlocked`,
		defaultMessage: 'Utente bloccato con successo',
	},
	failureBlocked: {
		id: `${customerCareScope}.failureBlocked`,
		defaultMessage: 'Blocco utente fallita',
	},
	successfullyBlockedCard: {
		id: `${customerCareScope}.successfullyBlockedCard`,
		defaultMessage: 'Carta bloccata con successo',
	},
	failureBlockedCard: {
		id: `${customerCareScope}.failureBlockedCard`,
		defaultMessage: 'Blocco carta fallito',
	},
	successfulOperation: {
		id: `${customerCareScope}.successfulOperation`,
		defaultMessage: 'Operazione completata con successo',
	},
	failedOperation: {
		id: `${customerCareScope}.failedOperation`,
		defaultMessage: 'Operazione fallita',
	},
	detailTitle: {
		id: `${customerCareScope}.detailTitle`,
		defaultMessage: 'Dettaglio utente',
	},
	deleteSubtitleUser: {
		id: `${customerCareScope}.deleteSubtitle`,
		defaultMessage: "dell'utente",
	},
	deleteSubtitleCard: {
		id: `${customerCareScope}.deleteSubtitleCard`,
		defaultMessage: 'della carta',
	},
	userData: {
		id: `${customerCareScope}.userData`,
		defaultMessage: 'Dati utente',
	},
	userStatus: {
		id: `${customerCareScope}.userStatus`,
		defaultMessage: 'Stato utente',
	},
	cardList: {
		id: `${customerCareScope}.cardList`,
		defaultMessage: 'Lista carte',
	},
	lastLogin: {
		id: `${customerCareScope}.lastLogin`,
		defaultMessage: 'Ultima login',
	},
	certifiedEmail: {
		id: `${customerCareScope}.certifiedEmail`,
		defaultMessage: 'Email certificata',
	},
	certifiedPhone: {
		id: `${customerCareScope}.certifiedPhone`,
		defaultMessage: 'Telefono certificata',
	},
	userId: {
		userId: `${customerCareScope}.userId`,
		defaultMessage: 'Id utente',
	},
	username: {
		id: `${customerCareScope}.username`,
		defaultMessage: 'Username',
	},
	phone: {
		id: `${customerCareScope}.phone`,
		defaultMessage: 'Numero di telefono',
	},
	subtitleEnable: {
		id: `${customerCareScope}.subtitleEnable`,
		defaultMessage: 'Sei sicuro di voler abilitare l’utente?',
	},
	subtitleDisable: {
		id: `${customerCareScope}.subtitleDisable`,
		defaultMessage: 'Sei sicuro di voler disabilitare l’utente?',
	},

	// Transaction Scope
	transactionId: {
		id: `${transactionsScope}.transactionId`,
		defaultMessage: 'ID Transazione',
	},
	merchantId: {
		id: `${transactionsScope}.merchantId`,
		defaultMessage: 'Merchant',
	},
	merchantName: {
		id: `${transactionsScope}.merchantName`,
		defaultMessage: 'Merchant',
	},
	currency: {
		id: `${transactionsScope}.currency`,
		defaultMessage: 'Valuta',
	},
	amount: {
		id: `${transactionsScope}.amount`,
		defaultMessage: 'Importo',
	},
	transactionStatus: {
		id: `${transactionsScope}.transactionStatus`,
		defaultMessage: 'Stato',
	},
	paymentChannel: {
		id: `${transactionsScope}.paymentChannel`,
		defaultMessage: 'Canale di pagamento',
	},
	paymentCardId: {
		id: `${transactionsScope}.paymentCardId`,
		defaultMessage: 'ID Carta',
	},
	cardExpirationDate: {
		id: `${transactionsScope}.cardExpirationDate`,
		defaultMessage: 'Data di scadenza',
	},
	circuit: {
		id: `${transactionsScope}.circuit`,
		defaultMessage: 'Circuito',
	},

	// Navigation Scope
	searchUser: {
		id: `${navigationScope}.customerCar.searchUser`,
		defaultMessage: 'Ricerca Utente',
	},
	searchTransactions: {
		id: `${navigationScope}.customerCar.searchTransactions`,
		defaultMessage: 'Ricerca Transazioni',
	},

	// Global Scope
	id: {
		id: `${globalScope}.id`,
		defaultMessage: 'Id',
	},
	groupName: {
		id: `${globalScope}.groupName`,
		defaultMessage: 'Gruppo',
	},
	name: {
		id: `${globalScope}.name`,
		defaultMessage: 'Nome',
	},
	surname: {
		id: `${globalScope}.surname`,
		defaultMessage: 'Cognome',
	},
	pinAttempts: {
		id: `${globalScope}.pinAttempts`,
		defaultMessage: 'Numero tentativi PIN',
	},
	email: {
		id: `${globalScope}.email`,
		defaultMessage: 'Email',
	},
	user: {
		id: `${globalScope}.user`,
		defaultMessage: 'Utente',
	},
	merchant: {
		id: `${globalScope}.merchant`,
		defaultMessage: 'Merchant',
	},
	abortLabelButton: {
		id: `${globalScope}.abort`,
		defaultMessage: 'Annulla',
	},
	confirmLabelButton: {
		id: `${globalScope}.confirm`,
		defaultMessage: 'Conferma',
	},
	warning: {
		id: `${globalScope}.warning`,
		defaultMessage: 'Attenzione',
	},
	subtitleDelete: {
		id: `${globalScope}.subtitleDelete`,
		defaultMessage: 'Sei sicuro di voler procedere alla cancellazione {element}?',
	},
	subtitleUnlock: {
		id: `${globalScope}.subtitleUnlock`,
		defaultMessage: 'L’utenza è stata bloccata a causa del superamento del numero massimo di tentativi per l’inserimento del PIN. Sei sicuro di voler sbloccare l’utente?',
	},
	unlock: {
		id: `${globalScope}.unlock`,
		defaultMessage: 'Sblocca',
	},
	enable: {
		id: `${globalScope}.enable`,
		defaultMessage: 'Abilita',
	},
	creationDate: {
		id: `${globalScope}.creationDate`,
		defaultMessage: 'Data creazione',
	},
	alias: {
		id: `${globalScope}.alias`,
		defaultMessage: 'Alias',
	},
	pan: {
		id: `${globalScope}.pan`,
		defaultMessage: 'Pan',
	},
	status: {
		id: `${globalScope}.status`,
		defaultMessage: 'Status',
	},

	// Global Error Scope
	invalidEmail: {
		id: `${globalErrorsScope}.invalidEmail`,
		defaultMessage: 'Email non valida',
	},
	invalidDate: {
		id: `${globalScope}.error.invalidDate`,
		defaultMessage: 'Data non valida',
	},
	theSecondDateIsMinorThanFirst: {
		id: `${globalErrorsScope}.theSecondDateIsMinorThanFirst`,
		defaultMessage: 'Data di fine troppo piccola',
	},
	fillFirstDateToContinueValidation: {
		id: `${globalErrorsScope}.fillFirstDateToContinueValidation`,
		defaultMessage: "Data d'inizio mancante",
	},
});
